module.exports = __webpack_public_path__ + "static/media/paint_gun.76e6218b.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/paint_gun.cur
// module id = 936
// module chunks = 0